module.exports = __webpack_public_path__ + "img/Angad.76932cb8.jpeg";